export default __webpack_public_path__ + "static/cp-app-5e8c1f6741edcc7b41e95c0bb2920e98.jpg";